import * as types from './types'
import moment from 'moment'
import globals from '@/Plugins/globals'
import storage from '@/Plugins/storage'
import store from '@/Store'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_CHECKED](state, data) {
    state.isChecked = false
    // for (let user of state.users) {
    //   if (user.id === data.id) {
    //     user.isChecked = data.isChecked
    //   }
    // }
    // for (let user of state.users) {
    //   if (user.isChecked) {
    //     state.isChecked = true
    //     break
    //   }
    // }
  },
  [types.RESET_CHALLENGE](state, data) {
    state.challenge = JSON.parse(JSON.stringify(state.defaultChallenge))
    state.challenge.orgId = data.orgid
    state.challenge.start_date = moment().add(7, 'd').startOf('week').toDate()
    state.challenge.visible_date = moment().add(7, 'd').startOf('week').toDate()
    state.challenge.end_date = moment().add(14, 'd').startOf('week').toDate()
  },
  [types.RESET_CHALLENGES](state, data) {
    state.challenges = []
  },
  [types.SET_CHALLENGES](state, data) {
    state.challenges = []
    if (data !== undefined && data !== null) {
      state.challenges = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got Challenges', state.challenges)
  },
  [types.SET_CHALLENGE](state, data) {
    state.challenge = []
    state.ruletypes = []
    state.weightTotal = 0
    if (data !== undefined && data !== null) {
      if (data.ruletypes) {
        state.ruletypes = data.ruletypes
        state.ruletypes.forEach((ruletype) => {
          if (ruletype.icon === null || ruletype.icon === '') {
            ruletype.isSetBackground = false
            ruletype.icon = globals.getActivityIcon(ruletype.name)
            if (ruletype.categories) {
              ruletype.categories.forEach((element) => {
                element.icon = globals.getRuleIcon(element.name)
              })
            }
          } else {
            ruletype.isSetBackground = true
          }
        })
      }
      if (data.challenge) {
        state.challenge = data.challenge
        if (state.challenge.sub_challenges) {
          state.challenge.sub_challenges.forEach((element) => {
            state.weightTotal += element.weight
            // Look for a matching ruletype and category based on sub_challenge rule and name
            const found = state.ruletypes.find(
              (x) => x.name === element.sub_challenge.name
            )
            if (found) {
              console.log('Found Rule Type', found)
              element.sub_challenge.isSetBackground = false
              if (found.icon !== '') {
                element.sub_challenge.icon = found.icon
                element.sub_challenge.isSetBackground = true
              } else {
                element.sub_challenge.icon = globals.getRuleIcon(
                  element.sub_challenge.rule
                )
              }
            } else {
              element.sub_challenge.icon = globals.getRuleIcon(
                element.sub_challenge.rule
              )
            }
            // let icon = globals.getRuleIcon(element.sub_challenge.rule)
            // element.sub_challenge.icon = icon
            if (element.sub_challenge.daily_goal !== null) {
              if (
                element.sub_challenge.rule === 'FoodThumbsUp' ||
                element.sub_challenge.rule === 'BodyFatLoss'
              ) {
                element.sub_challenge.subtitle = `${element.sub_challenge.daily_goal}%`
              } else if (
                element.sub_challenge.rule === 'WeightLoss' ||
                element.sub_challenge.rule === 'ProgressPhotos' ||
                element.sub_challenge.rule === 'Measurements'
              ) {
                element.sub_challenge.subtitle = `${element.sub_challenge.daily_goal}`
              } else {
                element.sub_challenge.subtitle = `${element.sub_challenge.daily_goal} per day`
              }
            } else if (element.sub_challenge.goal !== null) {
              if (element.sub_challenge.is_weekly) {
                element.sub_challenge.subtitle = `${element.sub_challenge.goal} per week`
              } else {
                element.sub_challenge.subtitle = `${element.sub_challenge.goal}`
              }
            }
          })
        }
        if (state.challenge.members) {
          let data = {
            name: 'currentSelected',
            members: [],
          }
          state.challenge.members.forEach((member) => {
            data.members.push({
              user_id: member.user_id,
              role: member.role,
            })
            store.dispatch('usercardio/setList', data)
          })
        }
        let last = null
        state.challenge.resources.forEach((resource) => {
          if (resource.sort === null) {
            if (last === null) {
              resource.sort = 0
            } else {
              resource.sort = last
            }
            last = resource.sort + 1
          }
        })
        state.challenge.resources = globals.sortArray(
          state.challenge.resources,
          'sort'
        )
      }
    }
    console.log('Got Challenge', {
      challenge: state.challenge,
      ruletypes: state.ruletypes,
    })
  },
  [types.SAVED_CHALLENGE](state, data) {
    if (data !== undefined && data !== null) {
      state.challenge = data
      state.challenge.isCopy = false
      if (state.challenge.sub_challenges) {
        state.challenge.sub_challenges.forEach((element) => {
          let icon = globals.getRuleIcon(element.sub_challenge.rule)
          element.sub_challenge.icon = icon

          if (element.sub_challenge.daily_goal !== null) {
            if (
              element.sub_challenge.rule === 'FoodThumbsUp' ||
              element.sub_challenge.rule === 'BodyFatLoss'
            ) {
              if (element.sub_challenge.rule === 'FoodThumbsUp') {
                element.sub_challenge.is_weekly = true
              } else {
                element.sub_challenge.is_weekly = false
              }
              element.sub_challenge.subtitle = `${element.sub_challenge.daily_goal}%`
            } else if (
              element.sub_challenge.rule === 'WeightLoss' ||
              element.sub_challenge.rule === 'ProgressPhotos' ||
              element.sub_challenge.rule === 'Measurements'
            ) {
              element.sub_challenge.is_weekly = false
              element.sub_challenge.subtitle = `${element.sub_challenge.daily_goal}`
            } else {
              if (element.sub_challenge.rule === 'FoodTracked') {
                element.sub_challenge.is_weekly = true
              }
              element.sub_challenge.subtitle = `${element.sub_challenge.daily_goal} per day`
            }
          } else if (element.sub_challenge.goal !== null) {
            if (element.sub_challenge.is_weekly) {
              element.sub_challenge.subtitle = `${element.sub_challenge.goal} per week`
            } else {
              element.sub_challenge.subtitle = `${element.sub_challenge.goal}`
            }
          }
        })
      }
    }
    console.log('Saved Challenge', {
      challenge: state.challenge,
      ruletypes: state.ruletypes,
    })
  },
  [types.SET_CHALLENGE_DATA](state, data) {
    switch (data.name) {
      case 'name': {
        state.challenge.name = data.value
        break
      }
      case 'orgid': {
        state.challenge.orgId = data.value
        break
      }
      case 'description': {
        state.challenge.description = data.value
        break
      }
      case 'start_date': {
        state.challenge.start_date = data.value
        if (state.challenge.isCopy) {
          if (state.challenge.isCopy) {
            if (state.challenge.resources) {
              state.challenge.resources.forEach((element) => {
                element.visibility_start_date = state.challenge.start_date
              })
            }
            if (state.challenge.sub_challenges) {
              state.challenge.sub_challenges.forEach((element) => {
                element.start_date = state.challenge.start_date
              })
            }
          }
        }
        break
      }
      case 'end_date': {
        state.challenge.end_date = data.value
        if (state.challenge.isCopy) {
          if (state.challenge.isCopy) {
            if (state.challenge.resources) {
              state.challenge.resources.forEach((element) => {
                element.visibility_end_date = state.challenge.end_date
              })
            }
            if (state.challenge.sub_challenges) {
              state.challenge.sub_challenges.forEach((element) => {
                element.end_date = state.challenge.end_date
              })
            }
          }
        }
        break
      }
      case 'closed': {
        state.challenge.closed = data.value
        break
      }
      case 'visible_date': {
        state.challenge.visible_date = data.value
        break
      }
      case 'resources': {
        state.challenge.resources = data.value
        break
      }
      case 'sub_challenges': {
        state.challenge.sub_challenges = data.value
        break
      }
      case 'edit-resource': {
        let found = state.challenge.resources.find(
          (x) => parseInt(x.id) === parseInt(data.value.id)
        )
        if (found) {
          found.name = data.value.name
          found.url = data.value.url
          found.required_time = data.value.required_time
          found.isChanged = true
          found.isResourceChanged = true
          found.start_date = `${moment(data.value.startDate).format(
            'YYYY-MM-DD'
          )} 00:00:00`
          found.end_date = `${moment(data.value.endDate).format(
            'YYYY-MM-DD'
          )} 00:00:00`
          found.visibility_start_date = `${moment(data.value.startDate).format(
            'YYYY-MM-DD'
          )} 00:00:00`
          found.visibility_end_date = `${moment(data.value.endDate).format(
            'YYYY-MM-DD'
          )} 00:00:00`
        }
        break
      }
      case 'add-resource': {
        // gather up existing ids
        let ids = []
        state.challenge.resources.forEach((element) => {
          ids.push(element.id)
        })
        ids.sort((a, b) => a - b)
        // increment the next id
        let nextId = -1
        if (ids[0] < 0) {
          nextId = ids[0] - 1
        }
        // build our new resource
        let addResource = JSON.parse(JSON.stringify(state.defaultResource))
        addResource.challenge_id = state.challenge.id
        addResource.id = nextId
        addResource.name = data.value.name
        addResource.url = data.value.url
        addResource.required_time = data.value.required_time
        addResource.isChanged = true
        addResource.visibility_start_date = `${moment(
          data.value.startDate
        ).format('YYYY-MM-DD')} 00:00:00`
        addResource.visibility_end_date = `${moment(data.value.endDate).format(
          'YYYY-MM-DD'
        )} 23:59:59`
        addResource.sort = state.challenge.resources.length
        // add it to the challenge
        state.challenge.resources.push(addResource)
        break
      }
      case 'remove-resource': {
        state.challenge.resources = state.challenge.resources.filter((el) => {
          return parseInt(el.id) !== parseInt(data.value)
        })
        break
      }
      case 'add-component': {
        // gather up existing ids
        let ids = []
        state.challenge.sub_challenges.forEach((element) => {
          ids.push(element.id)
        })
        ids.sort((a, b) => a - b)
        // increment the next id
        let nextId = -1
        if (ids[0] < 0) {
          nextId = ids[0] - 1
        }
        // build our new component sub-challenge
        let addComponent = JSON.parse(JSON.stringify(state.defaultComponent))
        addComponent.challenge_id = state.challenge.id
        addComponent.start_date = `${moment(data.value.startDate).format(
          'YYYY-MM-DD'
        )} 00:00:00`
        addComponent.end_date = `${moment(data.value.endDate).format(
          'YYYY-MM-DD'
        )} 23:59:59`
        addComponent.id = nextId
        addComponent.sub_challenge_id = nextId
        addComponent.sub_challenge.id = nextId
        addComponent.sub_challenge.name = data.value.name
        addComponent.sub_challenge.rule = data.value.rule
        addComponent.sub_challenge.isChanged = true
        if (data.value.rule.substring(0, 10) === 'dashboard_') {
          addComponent.sub_challenge.icon = data.value.icon
        } else {
          addComponent.sub_challenge.icon = globals.getRuleIcon(data.value.rule)
        }
        if (data.value.frequency === 2) {
          addComponent.sub_challenge.is_weekly = true
          addComponent.sub_challenge.daily_goal = null
          addComponent.sub_challenge.subtitle = `${data.value.goal} per week`
          addComponent.sub_challenge.goal = parseFloat(data.value.goal)
        } else {
          addComponent.sub_challenge.is_weekly = false
          addComponent.sub_challenge.daily_goal = parseFloat(data.value.goal)
          if (
            addComponent.sub_challenge.rule === 'FoodThumbsUp' ||
            addComponent.sub_challenge.rule === 'BodyFatLoss'
          ) {
            if (addComponent.sub_challenge.rule === 'FoodThumbsUp') {
              addComponent.sub_challenge.is_weekly = true
            } else {
              addComponent.sub_challenge.is_weekly = false
            }
            addComponent.sub_challenge.subtitle = `${data.value.goal}%`
          } else if (
            addComponent.sub_challenge.rule === 'WeightLoss' ||
            addComponent.sub_challenge.rule === 'ProgressPhotos' ||
            addComponent.sub_challenge.rule === 'Measurements'
          ) {
            addComponent.sub_challenge.is_weekly = false
            addComponent.sub_challenge.subtitle = `${data.value.goal}`
          } else {
            if (addComponent.sub_challenge.rule === 'FoodTracked') {
              addComponent.sub_challenge.is_weekly = true
            }
            addComponent.sub_challenge.subtitle = `${data.value.goal} per day`
          }
          addComponent.sub_challenge.goal = null
        }
        addComponent.sub_challenge.leaderboard = data.value.isLeaderboard
        if (data.value.weight) {
          addComponent.weight = data.value.weight
        }
        // add it to the challenge
        state.challenge.sub_challenges.push(addComponent)
        break
      }
      case 'remove-component': {
        state.challenge.sub_challenges = state.challenge.sub_challenges.filter(
          (el) => {
            return parseInt(el.id) !== parseInt(data.value)
          }
        )
        break
      }
      case 'members': {
        state.challenge.members = JSON.parse(JSON.stringify(data.value))
        break
      }
      case 'weight': {
        if (data.value) {
          let found = state.challenge.sub_challenges.find(
            (x) => x.id === data.value.id
          )
          if (found) {
            found.weight = data.value.weight
          }
        }
        let total = 0
        let isMet = false
        state.challenge.sub_challenges.forEach((element) => {
          if (isMet) {
            element.weight = 0
          } else {
            total += element.weight
            if (total > 100) {
              element.weight = element.weight - (total - 100)
              isMet = true
            }
          }
        })
        state.weightTotal = 0
        state.challenge.sub_challenges.forEach((element) => {
          state.weightTotal += element.weight
        })
        break
      }
      case 'copy': {
        state.challenge.id = null
        state.challenge.name = state.challenge.name + ' (copy)'
        state.challenge.isCopy = true
        break
      }
      case 'sort': {
        let len = 0
        let idx = 0
        var current = null
        var previous = null
        var next = null
        let change = 0
        len = state.challenge.resources.length
        idx = state.challenge.resources
          .map((e) => {
            return e.id
          })
          .indexOf(data.value)
        current = state.challenge.resources[idx]
        previous = state.challenge.resources[(idx + len - 1) % len]
        next = state.challenge.resources[(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.sort
          previous.sort = current.sort
          current.sort = change
          if (current.sort === previous.sort) {
            current.sort++
          }
        } else {
          change = next.sort
          next.sort = current.sort
          current.sort = change
          if (current.sort === next.sort) {
            next.sort++
          }
        }
        state.challenge.resources = globals.sortArray(
          state.challenge.resources,
          'sort'
        )
        break
      }
      case 'update-dates': {
        if (state.challenge.resources) {
          state.challenge.resources.forEach((element) => {
            let challengeStart = moment(state.challenge.visible_date)
            let challengeEnd = moment(state.challenge.end_date)
            // set base start/end for each resource to match the challenge
            element.start_date = state.challenge.start_date
            element.end_date = state.challenge.end_date
            element.visibility_end_date = state.challenge.end_date
            // if no visibility start/end, default them
            // to challenge start/end
            if (!element.visibility_start_date) {
              element.visibility_start_date = challengeStart
            }
            if (!element.visibility_end_date) {
              element.visibility_end_date = challengeEnd
            }
            let startDate = moment(element.visibility_start_date)
            // now check to see if the visiblity start are
            // within bounds of the challenge visibility start
            if (
              !startDate.isBetween(challengeStart, challengeEnd, null, '[]')
            ) {
              element.visibility_start_date = state.challenge.visible_date
            }
          })
        }
        if (state.challenge.sub_challenges) {
          state.challenge.sub_challenges.forEach((element) => {
            element.end_date = state.challenge.end_date
            element.start_date = state.challenge.start_date
          })
        }
        break
      }
    }
    console.log('Challenge Updated', state.challenge)
  },
  [types.SET_CHALLENGENAME](state, data) {
    state.challengeName = null
    if (data !== undefined && data !== null) {
      state.challengeName = data
    }
  },
}
